export const langAction = (payload) => ({
    type: "LANG",
    payload
})